import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export default function LoadingErrorState() {
    return <ErrorState headline={'Something went wrong. Reload or contact team marketplace.'} />;
}
